// extracted by mini-css-extract-plugin
export default {"select_wrapper":"LanguageSelector_select_wrapper__If0lO","select":"LanguageSelector_select__jBnx7"};